import type { SvgComponent } from '@/types/SvgComponent';

export const WorkspaceAssetsIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M3.75 6.25C3.75 5.55964 4.30964 5 5 5H7.5L9.16667 6.875H15C15.6904 6.875 16.25 7.43464 16.25 8.125V13.75C16.25 14.4404 15.6904 15 15 15H5C4.30964 15 3.75 14.4404 3.75 13.75V6.25Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.125 10.625H11.875" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
      <path d="M10 8.75V12.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  );
};
